import objectByID from './objectByID';
import { HANDLE_NEW_QDD } from '../actions/sync';
import { createSelector } from 'reselect'
import { UPDATE_SORT_INDEXES } from '../actions/question';
import { updateSortIndex } from "../sortIndex";

const questions = (state = [], action) => {
  switch(action.type) {
    case 'CREATE_QUESTION':
      var question = Object.assign({id: action.id, updatedAt: (new Date()).getTime()}, action.props);
      return [...state, question];
    case 'UPDATE_QUESTION':
      var question = objectByID(state, action.id);
      var index = state.indexOf(question);

      action.props.domainLogic = {
        caveats: Object.assign({}, question.domainLogic.caveats, action.props.domainLogic.caveats),
        criteria: Object.assign({}, question.domainLogic.criteria, action.props.domainLogic.criteria)
      }
      return [
        ...state.slice(0, index),
        Object.assign({}, question, action.props, {updatedAt: (new Date()).getTime()}),
        ...state.slice(index+1)
      ];
    case 'DELETE_QUESTION':
      var question = objectByID(state, action.id);
      var index = state.indexOf(question);
      return [
        ...state.slice(0, index),
        ...state.slice(index+1)
      ];
    case 'DELETE_OPTION':
      // gotta clean up all those caveats
      return state.map((question) => {
        let newCaveats = question.domainLogic.caveats || {};
        delete newCaveats[action.id];
        let newCriteria = question.domainLogic.criteria || {};
        delete newCriteria[action.id];
        return {
          ...question,
          domainLogic: {
            caveats: newCaveats,
            criteria: newCriteria
          }
        }
      });
    case 'DELETE_CATEGORY':
      return state.map((question) => {
        if (question.category === action.id) {
          return {
            ...question,
            category: action.reassignmentCategoryID
          }
        } else {
          return question;
        }
      });
    case 'UPDATE_OPTION':
    case 'CREATE_OPTION':
      let logic = action.domainLogic;
      if (logic && (logic.caveats || logic.criteria)) {
        let caveats = logic.caveats || {};
        let criteria = logic.criteria || {};
        return state.map((question) => {
          var newCaveats = {};
          if (caveats[question.id]) {
            newCaveats = Object.keys(caveats[question.id])[0] === "new" ? caveats[question.id]["new"] : caveats[question.id][action.id];
          }
          var newCriteria = null;
          if (criteria[question.id]) {
            newCriteria = Object.keys(criteria[question.id])[0] === "new" ? criteria[question.id]["new"] : criteria[question.id][action.id];
          }
          let domainLogic = {
            caveats: Object.assign({}, question.domainLogic.caveats,
              (Object.keys(newCaveats).length ? {[action.id]: newCaveats} : null)),
            criteria: Object.assign({}, question.domainLogic.criteria,
              (newCriteria && typeof newCriteria === 'object' ? {[action.id]: newCriteria} : null)),
          }
          return Object.assign({}, question, {domainLogic: domainLogic});
        });
      } else {
        return state;
      }
    case HANDLE_NEW_QDD:
      return action.payload.questions;
    case UPDATE_SORT_INDEXES:
      const ids = action.questions.map((q) => q.id);
      return state.map((q) => {
        var indexOf = ids.indexOf(q.id)
        if (indexOf === -1) {
          return q;
        } else {
          return {
            ...q,
            sortIndex: updateSortIndex(action.section, indexOf + 1, q.sortIndex)
          }
        }
      });
    default:
      return state;
  }
}

export default questions;

export const getAllQuestions = (state) => state.slice()

export const sortedQuestions = (state) => getAllQuestions(state).sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()))

//not used?
export const questionsByCategory = (state, categories) => {
  // let sorted = sortedQuestions(state);
  // let sections = {monitoring: [], assessment: [], controlRules: []};
  let byCategory = [];
  let blankCategoryQuestions = state.filter((q) => !q.category)
  if (blankCategoryQuestions.length) {
    byCategory.push({
      title: "No Category Specified",
      id: 0,
      questions: blankCategoryQuestions
    });
  }
  return categories.filter((c) => c.type === 'question').sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase())).map((category) => {
    return {
      ...category,
      questions: state.filter((q) => q.category === category.id)
    }
  });
}

const getQuestions = (state) => state.questions

export const questionLookup = createSelector([getQuestions], (questions) => {
  return questions.reduce((list, question) => {
    list[question.id] = question;
    return list;
  }, {});
});
